export interface IStack<T> {
    push(item: T): void;
    pop(): T | undefined;
    peek(): T | undefined;
    size(): number;
    isEmpty(): boolean;
}

export class Stack<T> implements IStack<T> {
    private _storage: T[] = [];

    constructor(private _capacity = Infinity) {}

    push(item: T): void {
        if (this.size() === this._capacity) {
            throw Error('Stack has reached max capacity, you cannot add more items');
        }
        this._storage.push(item);
    }

    pop(): T | undefined {
        return this._storage.pop();
    }

    peek(): T | undefined {
        return this._storage[this.size() - 1];
    }

    size(): number {
        return this._storage.length;
    }

    isEmpty(): boolean {
        return this._storage.length === 0;
    }
}
